export const defaultAppCTX = {
  str: "",
  // gameInfo: {
  //   balance: "",
  //   currency: "USD",
  //   history: [],
  //   maxBet: "",
  //   minBet: "",
  //   prec: 2,
  //   start_timer: null,
  //   user_id: "",
  //   user_name: "",
  // },
  auth: {
    balance: { amount: "", currency: "" },
    casino_id: "",
    currency_id: "",
    game_id: "",
    ip: "",
    login_params: "",
    player_id: "",
    player_name: "",
    provider_id: "",
    session_id: "",
  },
  config: {
    minbet: 0,
    maxbet: 0,
    prec: 2,
    rake: 1,
  },
  placedBetFirst: {
    bet: "",
    currency: "",
    state: "",
    error: {},
  },
  placedBetSecond: {
    bet: "",
    currency: "",
    state: "",
    error: {},
  },
  airdrop: {
    type: "",
    amount: "",
    balance: "",
  },
  jackpot: {
    status: "",
    progress_bars: {
      solar: 0,
      galactical: 0,
      stellar: 0,
    },
    board: [0, 0, 0, 0, 0, 0, 0, 0, 0], // 1 : 'solar' | 2 : 'galactical' | 3 : 'stellar'
    balance: "", // string,
    currency: "USD", // string,
    winamount: "",
    wintype: 0,
    // win: {
    //   type: '0', // 0: 'none'  | 1 : 'solar' | 2 : 'galactical' | 3 : 'stellar',
    //   amount: "0", // string,
    //   currency: "USD", // string
    // },
    timeleft: "",
  },
  jackpotState: {
    state: "",
  },
  jackpotInfo: {
    itemname: "",
    itemvalue: "",
    jackpotid: "",
    lockdata: "",
    locked: "",
    values: {},
    progress_bars: {},
    items: [],
    wintype: 0,
    winnercurrency: "",
    winnerid: "",
    winnername: "",
  },
  timer: "",
  audio: {
    sound: "100",
    music: "100",
    isMusicOff: false,
    isSoundOff: false,
  },
  userupdate: {
    room_id: "",
    start: 0,
    state: 0,
    value: "",
    coeff: "",
  },
  userupdateArray: [{}],
  balanceUpdate: {
    balance: "",
    bet: "",
    currency: "",
    index: "",
    type: "",
  },
  allPreviousRounds: [],
  roundUserUpdate: {
    type: "",
    id: "",
    name: "",
    index: "",
    state: 1,
    bet: 0,
    coeff: 0,
    cashout: 0,
    currency: "USD",
  },
  handleErrorText: "",
  globalSocketMessages: null,
  stellarSocketMessages: null,
  notification: null,
  handleNotification: (text) => {},
  notificationfadeOut: null,
  isError: false,
  errorText: "",
  appFuncs: {
    setMusic: (value) => {},
    setSound: (value) => {},
    setisMusicOff: (value) => {},
    setisSoundOff: (value) => {},
    setAudio: (value) => {},
    clearBetResponse: () => {},
    resetRoundUserUpdate: () => {},
  },
  history: {
    my: [],
    all: [],
    high: [],
  },
  roundupdate: {
    state: 0,
    value: 0,
    starttimer: 0,
  },
  placebet: {
    index: "",
    bet: "",
    currency: "",
    state: "",
    error: { code: 0 },
  },
  train: [],
  settings: {
    stakes: {
      firstStake: "",
      secondStake: "",
    },
    audio: { isMusicOff: false, isSoundOff: false, music: "50", sound: "50" },
  },
  jackpotIsActive: true,
};

export const defaultVauleCTX = {
  roundupdate: {
    state: 0,
    value: 0,
    starttimer: 0,
  },
};
export const defaultGameBoardCTX = {
  firstIsPlaying: false,
  secondIsPlaying: false,
  footerStates: {
    firstState: "bet",
    secondState: "bet",
  },
  stakes: {
    firstStake: "",
    secondStake: "",
  },
  auto: {
    first: {
      showAuto: false,
      numberOfBets: "0",
      cashOut: "0.20",
      betCount: 0,
      betsLeft: "",
    },
    second: {
      showAuto: false,
      numberOfBets: "0",
      cashOut: "0.20",
      betCount: 0,
      betsLeft: "",
    },
  },
  settings: {
    showSettings: false,
    settingsSubpage: "",
  },
  jackpotPopup: false,
  funcs: {
    handleShowAuto: (first, second, third) => {},
    handleStake: (first, second) => {},
    handleSettings: (b) => {},
    handleAutoInputs: (inputNumber, key, value) => {},
    handleAutoInputsSocket: (first, second, third) => {},
    setFooterFirstState: (state) => {},
    setFooterSecondState: (state) => {},
    handleSettingsSubpage: (page) => {},
    handleJackpotPopup: () => {},
  },
};

export const roundUserContext = [];
